import React from "react";
import { Typography, Box, Button, Grid, Card, List, ListItem, ListItemText } from "@mui/material";
import TriangleBackground from "../layout/TriangleBackground";
import LogoIcon from "../../assets/logo.png"; // your logo
import Slider from "react-slick"; // make sure to install react-slick and slick-carousel
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LanguageIcon from '@mui/icons-material/Language';
import SpeedIcon from '@mui/icons-material/Speed';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import AppsIcon from '@mui/icons-material/Apps';


// Example icons
import WebIcon from "@mui/icons-material/Web";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import CloudIcon from "@mui/icons-material/Cloud";
import StorageIcon from "@mui/icons-material/Storage";
import SmartToyIcon from "@mui/icons-material/SmartToy";
import careerimge from "../../assets/images/careerimg.jpeg";

const Services = ({ mode }) => {
    const DColors = ["#FF69B4", "#35ca35", "#FFA500", "#00BFFF"]; // pink, green, orange, blue




    const textSegments = [
        { text: "BLENDING " },
        { letter: "STRATEGY", color: DColors[0] },
        { text: ", " },
        { letter: "DESIGN ", color: DColors[1] },
        { text: ", " },
        { letter: "INNOVATION", color: DColors[2] },
        { text: "and " },
        { letter: "TECHNOLOGY ", color: DColors[3] }
    ];

    // Example services array
    const services = [
        {
            title: "Web Development",
            icon: <WebIcon fontSize="large" color="primary" />,
            points: ["Responsive websites", "Modern UI/UX", "SEO-friendly"],
        },
        {
            title: "Mobile Development",
            icon: <PhoneIphoneIcon fontSize="large" color="primary" />,
            points: ["iOS & Android apps", "Cross-platform", "Performance optimized"],
        },
        {
            title: "Cloud Computing",
            icon: <CloudIcon fontSize="large" color="primary" />,
            points: ["AWS, Azure, GCP", "Scalable infrastructure", "Serverless options"],
        },
        {
            title: "Middleware",
            icon: <StorageIcon fontSize="large" color="primary" />,
            points: ["Integration services", "APIs & messaging", "Data pipelines"],
        },
        {
            title: "GenAI",
            icon: <SmartToyIcon fontSize="large" color="primary" />,
            points: ["AI-powered solutions", "Automation", "Chatbots & NLP"],
        },
    ];

    // Slider settings
    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        pauseOnHover: false,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 3 } },
            { breakpoint: 900, settings: { slidesToShow: 2 } },
            { breakpoint: 600, settings: { slidesToShow: 1 } },
            { breakpoint: 480, settings: { slidesToShow: 1 } }, // Add more granular breakpoint for smaller devices
        ],
    };
    const GradientIconWrapper = ({ children }) => (
        <svg width="40" height="40" viewBox="0 0 40 40">
            <defs>
                <linearGradient id="gradient-icon" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stopColor="#FF69B4" />
                    <stop offset="25%" stopColor="#35ca35" />
                    <stop offset="50%" stopColor="#FFA500" />
                    <stop offset="100%" stopColor="#00BFFF" />
                </linearGradient>
            </defs>
            <foreignObject width="40" height="40">
                <Box
                    sx={{
                        width: "100%",
                        height: "100%",
                        "& svg": {
                            width: "100%",
                            height: "100%",
                            fill: "url(#gradient-icon)",
                        },
                    }}
                >
                    {children}
                </Box>
            </foreignObject>
        </svg>
    );


    return (
        <div>
            {/* === Hero Section with Triangle Background === */}
            <TriangleBackground mode={mode}>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: "center",
                        justifyContent: "center",
                        px: 2,
                        gap: 4,
                        height: "100%",
                    }}
                >
                    {/* Content on the left */}
                    <Box
                        sx={{
                            width: { xs: "100%", md: "50%" },
                            textAlign: { xs: "center", md: "left" },
                        }}
                    >

                        <Typography
                            variant="h3"
                            sx={{
                                fontWeight: "bold",
                                mb: 2,
                                color: mode === "dark" ? "#fff" : "#000",
                            }}
                        >
                            {textSegments.map((seg, idx) =>
                                seg.letter ? (
                                    <span key={idx} style={{ color: seg.color }}>
                                        {seg.letter}
                                    </span>
                                ) : (
                                    <span key={idx}>{seg.text}</span>
                                )
                            )}
                        </Typography>
                        <Typography
                            variant="h4"

                            sx={{ color: mode === "dark" ? "#ccc" : "#444", mb: 4 }}
                        >
                            We are happy and passionate people committed to solving big problems
                        </Typography>

                        <Typography
                            variant="h6"
                            className="fade-slide-text"
                            sx={{ color: mode === "dark" ? "#ccc" : "#444" }}
                        >
                            One Stop Solution for Technology
                        </Typography>
                    </Box>

                    {/* Logo on the right */}
                    <Box
                        component="img"
                        src={LogoIcon}
                        alt="Olyviatech Logo"
                        className="spin-fade-logo"
                        sx={{
                            width: { xs: 120, sm: 150, md: 250, opacity: 0.5 },
                            height: "auto",
                        }}
                    />
                </Box>
            </TriangleBackground>
            {/* === Services We Provide Section === */}
            <section
                style={{
                    position: "relative",
                    padding: "100px 20px",
                    backgroundColor: mode === "dark" ? "#111" : "#f5f5f5",
                    overflow: "hidden",
                }}
            >
                {/* Background Logo */}
                <Box
                    component="img"
                    src={LogoIcon} // Update with your actual logo path
                    alt="Olyvia Tech Logo"
                    sx={{
                        position: "absolute",
                        top: "50%",
                        left: "20%",
                        transform: "translate(-50%, -50%)",
                        opacity: 0.5,
                        width: { xs: "150%", md: "1000px" },
                        height: "auto",
                        zIndex: 0,
                        pointerEvents: "none",
                        userSelect: "none",
                    }}
                />

                {/* Content */}
                <Box sx={{ maxWidth: "1400px", mx: "auto", position: "relative", zIndex: 1 }}>
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: "bold",
                            textAlign: "center",
                            mb: 6,
                            color: mode === "dark" ? "#fff" : "#000",
                        }}
                    >
                        Services We Provide
                    </Typography>

                    <Grid
                        container
                        spacing={3}
                        justifyContent="center"
                        sx={{
                            maxWidth: "1100px",
                            mx: "auto",
                        }}
                    >
                        {[
                            {
                                title: "Web Development",
                                icon: <LanguageIcon />,
                                description: "We build high-quality, responsive websites tailored to business needs.",
                                points: ["Custom Web Applications", "E-commerce Platforms", "CMS Integration"],
                            },
                            {
                                title: "Mobile Development",
                                icon: <PhoneIphoneIcon />,
                                description: "iOS and Android apps using native and cross-platform tech.",
                                points: ["Flutter & React Native", "Native Android/iOS", "App Store Deployment"],
                            },
                            {
                                title: "Cloud Computing",
                                icon: <CloudIcon />,
                                description: "Robust, scalable, cloud-native architectures.",
                                points: ["AWS / Azure / GCP", "Serverless Solutions", "CI/CD & Monitoring"],
                            },
                            {
                                title: "CDN Solutions",
                                icon: <SpeedIcon />,
                                description: "Accelerated performance through content delivery networks.",
                                points: ["Multi CDN Migrations", "Global Delivery", "Caching Strategies"],
                            },
                            {
                                title: "Middleware",
                                icon: <StorageIcon />,
                                description: "Secure APIs & service orchestration for enterprise apps.",
                                points: ["API Gateways", "Message Brokers", "Authentication Layers"],
                            },
                            {
                                title: "Gen AI",
                                icon: <SmartToyIcon />,
                                description: "AI-driven automation & conversation interfaces.",
                                points: ["Custom Chatbots", "Text Summarization", "Prompt Engineering"],
                            },
                            {
                                title: "Innovation Tech",
                                icon: <LightbulbIcon />,
                                description: "Explore bleeding-edge tech to future-proof your business.",
                                points: ["AR/VR", "IoT Solutions", "Blockchain Use Cases"],
                            },
                            {
                                title: "Enterprise App Development",
                                icon: <AppsIcon />,
                                description: "Large-scale app solutions for internal & external use.",
                                points: ["CRM Systems", "ERP Integrations", "Data-Driven Dashboards"],
                            },
                        ].map((service, index) => (
                            <Grid
                                item
                                xs={12}
                                sm={6}
                                md={3}
                                key={index}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <Card
                                    sx={{
                                        width: 260,
                                        height: 320,
                                        position: "relative",
                                        overflow: "hidden",
                                        borderRadius: 3,
                                        boxShadow: 3,
                                        backgroundColor: mode === "dark" ? "#1a1a1a" : "#fff",
                                        color: mode === "dark" ? "#fff" : "#000",
                                        cursor: "pointer",
                                        transition: "transform 0.3s ease",
                                        "&:hover .card-main": {
                                            transform: "translateY(-50px)",
                                        },
                                        "&:hover .card-reveal": {
                                            opacity: 1,
                                            transform: "translateY(0)",
                                        },
                                    }}
                                >
                                    {/* Icon + Title Centered */}
                                    <Box
                                        className="card-main"
                                        sx={{
                                            height: "100%",
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            transition: "transform 0.4s ease",
                                            px: 2,
                                        }}
                                    >
                                        <Box sx={{ mb: 1 }}>
                                            <GradientIconWrapper>
                                                {React.cloneElement(service.icon, { fontSize: "inherit" })}
                                            </GradientIconWrapper>
                                        </Box>

                                        <Typography variant="h6" sx={{ fontWeight: "bold", textAlign: "center" }}>
                                            {service.title}
                                        </Typography>
                                    </Box>

                                    {/* Reveal Content */}
                                    <Box
                                        className="card-reveal"
                                        sx={{
                                            position: "absolute",
                                            bottom: 0,
                                            left: 0,
                                            right: 0,
                                            px: 2,
                                            py: 2,
                                            backgroundColor: mode === "dark" ? "#222" : "#f2f2f2",
                                            color: mode === "dark" ? "#ccc" : "#444",
                                            opacity: 0,
                                            transform: "translateY(20px)",
                                            transition: "all 0.4s ease",
                                            fontSize: "0.85rem",
                                        }}
                                    >
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            {service.description}
                                        </Typography>
                                        <ul style={{ paddingLeft: 16, margin: 0 }}>
                                            {service.points.map((point, i) => (
                                                <li key={i} style={{ marginBottom: "4px" }}>
                                                    {point}
                                                </li>
                                            ))}
                                        </ul>
                                    </Box>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>




                </Box>
            </section>



            {/* === CTA Section: Have a Question? === */}

            <section
                style={{
                    position: "relative",
                    padding: "120px 20px",
                    backgroundColor: "#000", // force dark background for stars
                    overflow: "hidden",
                }}
            >
                {/* Animated stars background */}
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundImage: `
        radial-gradient(white 1px, transparent 1px),
        radial-gradient(white 1px, transparent 1px)
      `,
                        backgroundSize: "40px 40px",
                        backgroundPosition: "0 0, 20px 20px",
                        animation: "moveStars 60s linear infinite",
                        opacity: 0.5,
                        zIndex: 0,
                    }}
                />

                {/* Foreground content */}
                <Box
                    sx={{
                        position: "relative",
                        zIndex: 2,
                        maxWidth: "800px",
                        mx: "auto",
                        textAlign: "center",
                    }}
                >
                    <Typography
                        variant="h4"
                        sx={{
                            fontWeight: "bold",
                            color: "#fff",
                            mb: 4,
                        }}
                    >
                        Have a question? We're happy to help
                    </Typography>

                    <Button
                        variant="contained"
                        href="/contact"
                        sx={{
                            backgroundColor: "#4caf50",
                            color: "#ffff",
                            fontWeight: "bold",
                            px: 5,
                            py: 1.5,
                            fontSize: "1rem",
                            borderRadius: "8px",
                            '&:hover': {
                                backgroundColor: "#43a047",
                            },
                        }}
                    >
                        Contact Us →
                    </Button>
                </Box>
            </section>




            {/* <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Careers
        </Typography>
        <Typography variant="body1">[ Add careers info here ]</Typography>
      </section>

      <section style={{ padding: "80px 20px", textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          Contact Us
        </Typography>
        <Typography variant="body1">[ Add contact form here ]</Typography>
      </section> */}
        </div>
    );
};

export default Services;
